import React, { useEffect, useLayoutEffect } from "react";
import HeaderBar from "components/v1/HeaderBar";
import Navigation from "components/v1/Navigation";
import { Outlet, useNavigate, useLocation } from "react-router";
import { ContainerView } from "router/styles";
import useUser from "../../hooks/useUser";
import authService from "services/authService";
import {isPathStrictlyV1, userHasViewPermission} from "../../utlis/utils.js"

function Container() {
  const location = useLocation();
  const { getToken } = useUser();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    const token = getToken();
    const isTokenExpired = token && authService.IsTokenAboutToExpired();
    if (!token || isTokenExpired) {
      navigate("/corporate");
    }
  }, [location]);

  const headerDisplayHandler = () => {
    if(isPathStrictlyV1() && userHasViewPermission()) {
      return;
    }
    return <HeaderBar />
  }

  return (
    <ContainerView style={{ backgroundColor: '' }}>
      <Navigation />
      <section>
        {headerDisplayHandler()}
        <section
          style={{
            padding: "31px 0px",
            maxWidth: "1600px",
          }}
        >
          <Outlet />
        </section>
      </section>
    </ContainerView>
  );
}

export default Container;
